export default __webpack_public_path__ + "static/media/Prarthna.13ce3260.jpg";